//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import TeacherOptionsForm from "../parent-flow/forms/TeacherOptionForm";
import { useFormSubmission } from "../../utils/hooks";
import { transformSplit } from "./business-logic/request-splitter";
import { FormContainer } from "./components/FormWrapper";
import { RequestDataContext } from "./RequestDataProvider";
import { determineNoOfTeachers } from "./store";
export { determineNoOfTeachers };
export const useTeacherFormHook = (toNextPage, onSubmit, sessionID) => {
  let {
    requestData: { childDetails, splitRequests },
    onUpdateRequestSplit,
    generateSearchSubject,
  }: any = useContext(RequestDataContext);
  let teacherSplitOptions = transformSplit(childDetails);
  console.log({ teacherSplitOptions: Object.values(teacherSplitOptions) });
  let initialTeacherOption =
    splitRequests.length > 0 ? splitRequests[0].teacherOption : "";

  let teacherOptions = Object.keys(teacherSplitOptions);
  let initialInputValue = teacherOptions.includes(initialTeacherOption)
    ? initialTeacherOption
    : "";
  const onSubmitForm = (data) => {
    let selectedOption = data["teacherOption"];
    let splitValue = teacherSplitOptions[selectedOption];
    let finalValue = generateSearchSubject(splitValue);
    let r = onUpdateRequestSplit(finalValue);
    return r;
  };
  let [loading, handleSubmit] = useFormSubmission(
    onSubmit,
    toNextPage,
    onSubmitForm,
    sessionID
  );
  return { handleSubmit, loading, initialInputValue, teacherSplitOptions };
};

const formCopy = {
  heading: "How many tutors do you want?",
  description:
    "Based on your subjects and classes, we have the following options for how to split this among the tutors.",
};

type TeacherFormPageProps = {
  onSubmit: any;
  viewModel: any;
  teacherSplitOptions: any;
  updateFormIndex: any;
  loading: boolean;
  nextButtonText?: string;
  initialValues: {
    teacherOption: any;
    gender?: string[];
  };
  [key: string]: any;
};

const TeacherFormPage: React.FC<TeacherFormPageProps> = observer(
  ({
    onSubmit,
    viewModel,
    teacherSplitOptions,
    updateFormIndex,
    loading,
    initialValues,
    nextButtonText,
    ...props
  }) => {
    return (
      <FormContainer {...formCopy} {...props}>
        <TeacherOptionsForm
          onSubmit={onSubmit}
          initialValues={initialValues}
          updateFormIndex={updateFormIndex}
          viewModel={viewModel}
          dataInput={teacherSplitOptions}
          loading={loading}
          nextButtonText={nextButtonText}
        />
      </FormContainer>
    );
  }
);

export default TeacherFormPage;
